// Taken line for line from pst-viewer repo, then modified to be more powerful since we will mainly be using this

import { ByteReader } from '../gflib/src/lib/byte-reader/types';
import { Buffer } from 'buffer';

// implements ByteReader
export class ByteReaderBrowser implements ByteReader {
	private _file: File;
	constructor(file: File) {
		this._file = file;
	}

	readBytes(start: number, end?: number) {
		return new Promise<Buffer>((resolve, reject) => {
			const reader = new FileReader();

			reader.onloadend = evt => {
				const target = evt.target as any;
				if (target.readyState === FileReader.prototype.DONE) {
					resolve(Buffer.from(target.result));
				}
			};
			let blob: Blob;
			if (end !== undefined) {
				blob = this._file.slice(start, end);
			} else {
				blob = this._file.slice(start);
			}
			reader.readAsArrayBuffer(blob);
		});
	}
}

export default ByteReaderBrowser;
